// Stockage du session token BetterAuth pour l'app native Capacitor.
//
// Sur le web, BetterAuth gère l'auth via cookie same-origin — rien ici.
// En natif (capacitor://localhost), les cookies tiers sont bloqués : on
// capte le token dans la réponse (header `set-auth-token` ou corps
// `data.token`) et on le conserve dans localStorage (qui persiste entre
// les lancements de la WebView Capacitor).

const STORAGE_KEY = "rws_native_token";

/** Lit le token stocké, ou null si absent. */
export function getNativeToken(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

/** Persiste le token après une connexion réussie. */
export function setNativeToken(token: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, token);
  } catch {
    // localStorage indisponible — ignoré silencieusement
  }
}

/** Supprime le token (déconnexion). */
export function clearNativeToken(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignoré
  }
}
